import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  ClipboardList,
  FilePlus,
  Package,
  Truck,
  UserCog,
  UserPlus,
  UsersRound,
} from "lucide-react";
import http from "../api/http";

export default function Dashboard() {
  const [stats, setStats] = useState({
    clientes: 0,
    proveedores: 0,
    productos: 0,
    mercaderia: 0,
  });

  useEffect(() => {
    const load = async () => {
      const [clientesRes, proveedoresRes, productosRes, mercaderiaRes] = await Promise.all([
        http.get("/clientes"),
        http.get("/proveedores"),
        http.get("/productos"),
        http.get("/mercaderia"),
      ]);

      setStats({
        clientes: clientesRes.data.length,
        proveedores: proveedoresRes.data.length,
        productos: productosRes.data.length,
        mercaderia: mercaderiaRes.data.length,
      });
    };

    load().catch(() => {});
  }, []);

  return (
    <>
      <section className="kpi-grid">
        <div className="kpi">
          <span>Clientes cargados</span>
          <strong>{stats.clientes}</strong>
        </div>
        <div className="kpi">
          <span>Proveedores</span>
          <strong>{stats.proveedores}</strong>
        </div>
        <div className="kpi">
          <span>Productos</span>
          <strong>{stats.productos}</strong>
        </div>
        <div className="kpi">
          <span>Ingresos mercaderia</span>
          <strong>{stats.mercaderia}</strong>
        </div>
      </section>

      <section className="dashboard-grid">
        <div className="panel panel-pad dashboard-panel dashboard-modules">
          <h2>Modulos principales</h2>
          <div className="module-list">
            <ModuleLink
              to="/clientes/pacientes"
              title="Clientes"
              text="Alta, edicion, busqueda y eliminacion."
              icon={<UsersRound size={20} />}
            />
            <ModuleLink
              to="/usuarios"
              title="Usuarios"
              text="Administradores, vendedores y cajeros."
              icon={<UserCog size={20} />}
            />
            <ModuleLink
              to="/proveedores"
              title="Proveedores"
              text="Datos comerciales y productos asociados."
              icon={<Truck size={20} />}
            />
            <ModuleLink
              to="/productos"
              title="Productos"
              text="Catalogo unico y recetas de produccion."
              icon={<Package size={20} />}
            />
            <ModuleLink
              to="/mercaderia"
              title="Ingresos de envases/materias primas"
              text="Ingresos de productos, materiales, lotes y tracking."
              icon={<Package size={20} />}
            />
            <ModuleLink
              to="/operaciones"
              title="Operaciones"
              text="Pedidos, fraccionamiento y produccion."
              icon={<ClipboardList size={20} />}
            />
          </div>
        </div>

        <div className="panel panel-pad dashboard-panel dashboard-quick-access">
          <h2>Accesos rapidos</h2>
          <div className="module-list">
            <QuickLink to="/clientes/pacientes?nuevo=1" className="btn btn-primary" icon={<UserPlus size={18} />}>
              Nuevo cliente
            </QuickLink>
            <QuickLink to="/proveedores?nuevo=1" className="btn" icon={<Truck size={18} />}>
              Nuevo proveedor
            </QuickLink>
            <QuickLink to="/productos?nuevo=1" className="btn btn-green" icon={<FilePlus size={18} />}>
              Nuevo producto
            </QuickLink>
            <QuickLink to="/mercaderia?nuevo=1" className="btn btn-green" icon={<Package size={18} />}>
              Nuevo ingreso
            </QuickLink>
            <QuickLink to="/usuarios?nuevo=1" className="btn" icon={<UserCog size={18} />}>
              Nuevo usuario
            </QuickLink>
          </div>
        </div>
      </section>
    </>
  );
}

function ModuleLink({ to, title, text, icon }) {
  return (
    <Link className="module-item" to={to}>
      <div>
        <strong>{title}</strong>
        <span>{text}</span>
      </div>
      {icon}
    </Link>
  );
}

function QuickLink({ to, className, icon, children }) {
  return (
    <Link className={className} to={to}>
      {icon}
      {children}
      <ArrowRight size={17} />
    </Link>
  );
}
